import { Typography } from '@mui/material';
import * as React from 'react';
import { ChannelItemWebEvent } from '../../../../sic-lib/types/ChannelItem';

interface Props {
    channelItem: ChannelItemWebEvent;
}

export default React.memo(function ConversationListItemWebEvent({ channelItem }: Props) {
    return (
        <Typography variant="body1" display="block" whiteSpace="pre-wrap" p={2}>
            {channelItem.text}
        </Typography>
    );
});
